var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComboNone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_454_43661)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bright-fill",
    d: "M8 4.55005C8.015 5.09005 8.24 5.57505 8.6 5.93005L1.05 9.21005C0.95 9.25505 0.85 9.27505 0.75 9.27505C0.355 9.27505 0 8.95005 0 8.52005C0 8.22505 0.175 7.95505 0.45 7.83505L8 4.55005Z",
    fill: "#D0D7DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bright-fill",
    d: "M20.0004 8.52005C20.0004 9.06005 19.4454 9.42505 18.9504 9.21005L11.4004 5.93005C11.7604 5.57505 11.9854 5.09005 12.0004 4.55005L19.5504 7.83505C19.8254 7.95505 20.0004 8.22505 20.0004 8.52005Z",
    fill: "#D0D7DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bright-fill",
    d: "M16.5 24H3.5C2.95 24 2.5 23.55 2.5 23V14C2.5 12.345 3.845 11 5.5 11H14.5C16.155 11 17.5 12.345 17.5 14V23C17.5 23.55 17.05 24 16.5 24Z",
    fill: "#D0D7DE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M12 4.5V4.55C11.985 5.09 11.76 5.575 11.4 5.93C11.035 6.28 10.545 6.5 10 6.5C9.455 6.5 8.965 6.28 8.6 5.93C8.24 5.575 8.015 5.09 8 4.55V4.5C8 3.395 8.895 2.5 10 2.5C11.105 2.5 12 3.395 12 4.5Z",
    fill: "#AFB8C1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_454_43661"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComboNone);
export default __webpack_public_path__ + "static/media/combo-none.c19a215916da7a5d4f93af01e4cfd395.svg";
export { ForwardRef as ReactComponent };